var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdGooglegoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8541 7.53119H16.25V7.50006H9.5V10.5001H13.7386C13.1202 12.2464 11.4586 13.5001 9.5 13.5001C7.01487 13.5001 5 11.4852 5 9.00006C5 6.51494 7.01487 4.50006 9.5 4.50006C10.6471 4.50006 11.6907 4.93281 12.4854 5.63969L14.6067 3.51831C13.2672 2.26994 11.4755 1.50006 9.5 1.50006C5.35812 1.50006 2 4.85819 2 9.00006C2 13.1419 5.35812 16.5001 9.5 16.5001C13.6419 16.5001 17 13.1419 17 9.00006C17 8.49719 16.9482 8.00631 16.8541 7.53119Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86475 5.50919L5.32887 7.31631C5.99562 5.66556 7.61037 4.50006 9.5 4.50006C10.6471 4.50006 11.6907 4.93281 12.4854 5.63969L14.6067 3.51831C13.2672 2.26994 11.4755 1.50006 9.5 1.50006C6.61925 1.50006 4.121 3.12644 2.86475 5.50919Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50012 16.5C11.4374 16.5 13.1976 15.7586 14.5285 14.553L12.2072 12.5888C11.4289 13.1807 10.4779 13.5008 9.50012 13.5C7.54937 13.5 5.89299 12.2561 5.26899 10.5203L2.82324 12.4046C4.06449 14.8335 6.58524 16.5 9.50012 16.5Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8541 7.53113H16.25V7.5H9.5V10.5H13.7386C13.4428 11.3312 12.91 12.0574 12.206 12.5891L12.2071 12.5884L14.5284 14.5526C14.3641 14.7019 17 12.75 17 9C17 8.49712 16.9482 8.00625 16.8541 7.53113Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdGooglegoogleIcon);
export default __webpack_public_path__ + "static/media/md-googlegoogle-icon.b9b05ef95cd7607f138a73d67a6e15ce.svg";
export { ForwardRef as ReactComponent };